import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import '../styles.css';
import Ham from './Ham';
import { GAL_EDITIONS } from '../data/galEditions';
import HEBREW_EDITIONS from '../data/hebrewEditions.json';
import GREEK_EDITIONS from '../data/greekEditions.json';

function Header({ bible, title, description, url, image, subon, galEdition = false }) {
  const location = useLocation();
  const [pageType, setPageType] = useState('norm');
  const [isSmartphone, setIsSmartphone] = useState(false);
  const [visitorCount, setVisitorCount] = useState(null);
  const headerTitle = `${process.env.PUBLIC_URL}/static/images/blog/title.png`;
  const headerHref = '/';
  const typeHref = (type) => {
    const params = new URLSearchParams(location.search);
    params.set('type', type);
    return `${location.pathname}?${params.toString()}`;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmartphone(window.innerWidth < 768);
    };

    // Initial check and listener for resize
    handleResize();
    window.addEventListener('resize', handleResize);

    // Cleanup listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const currentRuby = urlParams.get('type');
    setPageType(currentRuby || 'norm');
  }, []);

  useEffect(() => {
    let cancelled = false;

    const fetchVisitorCount = async () => {
      try {
        const response = await fetch('/api/visitor-count');
        if (!response.ok) {
          throw new Error('Failed to fetch visitor count');
        }
        const data = await response.json();
        if (cancelled) {
          return;
        }
        const totalVisitors = Number(data?.totalVisitors);
        setVisitorCount(Number.isFinite(totalVisitors) ? totalVisitors : null);
      } catch (error) {
        if (!cancelled) {
          setVisitorCount(null);
        }
      }
    };

    fetchVisitorCount();

    return () => {
      cancelled = true;
    };
  }, []);

  const toggleRuby = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let newState;

    if (pageType === 'norm') {
      newState = 'ruby';
    } else if (pageType === 'ruby') {
      newState = 'en';
    } else {
      newState = 'norm';
    }

    urlParams.set('type', newState);
    window.location.search = urlParams.toString(); // Reload the page with the new state

    setPageType(newState); // Update the state
  };

  const toggleLang = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let newState;

    if (pageType === 'norm') {
      newState = 'en';
    } else {
      newState = 'norm';
    }

    urlParams.set('type', newState);
    window.location.search = urlParams.toString(); // Reload the page with the new state

    setPageType(newState); // Update the state
  };

  const formattedVisitorNumber = visitorCount === null
    ? null
    : visitorCount.toLocaleString('ja-JP');
  const visitorMessage = formattedVisitorNumber
    ? `訪問者数：${formattedVisitorNumber}`
    : null;
  const visitorMobileClassName = `visitor-counter-mobile${subon ? ' visitor-counter-mobile--after-sub' : ''}`;

  return (
    <div>

      <div className="header">
        <Helmet>
          <script>
            {`
              !function(e,t,n,s,u,a){
                e.twq||(s=e.twq=function(){
                  s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
                },
                s.version='1.1',
                s.queue=[],
                u=t.createElement(n),
                u.async=!0,
                u.src='https://static.ads-twitter.com/uwt.js',
                a=t.getElementsByTagName(n)[0],
                a.parentNode.insertBefore(u,a))
              }(window,document,'script');
              twq('config','puq2w');
            `}
          </script>
          <script>
            {`
              twq('event', 'Purchase'); // or use 'tw-puq2w-puq2x' only if that's a custom event defined in your campaign
            `}
          </script>
          <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16949700128"></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-16949700128');
            `}
          </script>
        
          <meta charSet="UTF-8" />
          <link rel="icon" href="/static/favicon/favicon.ico" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>{title || "ASMRキリスト教会"}</title>
          <meta name="description" content={description || "10代〜20代の若者へ..."} />
          <meta name="keywords" content="聖書, キリスト教, ASMR, 教会" />
        
          {/* Open Graph / Facebook */}
          <meta property="og:type" content="article" />
          <meta property="og:title" content={title || "ASMRキリスト教会"} />
          <meta property="og:description" content={description || "口語訳聖書 旧約：1955年版・新約：1954年版 ルビ付き・振り仮名付き"} />
          <meta property="og:url" content={url || "https://www.asmrchurch.com"} />
          <meta property="og:image" content={image || "https://www.asmrchurch.com/static/images/i4.jpg"} />
        
          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={title || "ASMRキリスト教会"} />
          <meta name="twitter:description" content={description || "10代〜20代の若者へ..."} />
          <meta name="twitter:url" content={url || "https://www.asmrchurch.com"} />
          <meta name="twitter:image" content={image || "https://www.asmrchurch.com/static/images/i4.jpg"} />
        </Helmet>

        <div className="c1 header-brand">
          <a href={headerHref}>
            {galEdition ? (
              <span className="gal-wordmark">ギャル訳<span aria-hidden="true">♥</span></span>
            ) : (
              <img src={headerTitle} alt="ASMRキリスト教会" className="header-title-image" />
            )}
          </a>
          {!isSmartphone && visitorMessage && (
            <div className="visitor-counter-inline" aria-live="polite">
              <span className="visitor-counter-text">{visitorMessage}</span>
            </div>
          )}
        </div>

        <div className="c11">
        {!isSmartphone && (
               <span>
               <span className="ind"><a href="/" >Home</a></span>
               <span className="pipe">| </span>
               <span className="ind"><a href="/article/2">概要</a></span>
               <span className="pipe">| </span>
               <span className="ind"><a href="https://note.com/asmrchurch" target="_blank" rel="noopener noreferrer">Blog</a></span>
               <span className="pipe">| </span>
               <span className="ind"><a href="/sermon">説教</a></span>
               <span className="pipe">| </span>
               <span className="ind"><a href="/manga">漫画</a></span>
               <span className="pipe">| </span>
               <span className="ind"><a href="/jobs">Jobs</a></span>
               <span className="pipe">| </span>
               <span className="ind"><a href="https://asmrchurch.fanbox.cc/shop">SHOP</a></span>
               </span>
        )}
        </div>

        <div className="c3">
          <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@asmrchurch">
            <img
              className="logo"
              src={`${process.env.PUBLIC_URL}/static/images/youtube.png`}
              alt="YouTube logo"
            />
          </a>
      </div>

      {/* Render Ham only for smartphones */}
      {isSmartphone && (
        <div className="ham">
          <Ham />
        </div>
      )}

      </div>

      {isSmartphone && visitorMessage && (
        <div className={visitorMobileClassName} aria-live="polite">
          <span className="visitor-counter-text">{visitorMessage}</span>
        </div>
      )}

     {subon === true && (
       <div className="csub">
         <div className="ll">
           <a className="al lang-button" href={typeHref('norm')}>日本語</a>
           <a className="al lang-button" href={typeHref('ruby')}>かな</a>
           <a className="al lang-button" href={typeHref('en')}>English</a>
           {Object.hasOwn(GAL_EDITIONS, location.pathname.split('/')[2]) && location.pathname.startsWith('/bible/') && (
             <a className="al lang-button" href={typeHref('gal')}>ギャル</a>
           )}
           {location.pathname.startsWith('/bible/') && Object.hasOwn(HEBREW_EDITIONS, location.pathname.split('/')[2]) && (
             <a className="al lang-button" href={typeHref('hebrew')}>原語</a>
           )}
           {location.pathname.startsWith('/bible/') && Object.hasOwn(GREEK_EDITIONS, location.pathname.split('/')[2]) && (
             <a className="al lang-button" href={typeHref('greek')}>原語</a>
           )}
         </div>
       </div>
      )}
    </div>
  );
}

export default Header;
